import { useSelector, shallowEqual } from "react-redux";
import Trustpilot from "app/features/booking/components/Trustpilot/Trustpilot";
import { getBrandDisplayName } from "app/reducers/partnerSelector";

const mapStateToProps = state => {
	return {
		brandDisplayName: getBrandDisplayName(state),
		rating: state.trustpilot.rating,
		totalReviews: state.trustpilot.totalReviews,
	};
};

const TrustpilotContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	return <Trustpilot {...props} {...stateProps} />;
};

export default TrustpilotContainer;
